// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productListAttributeFiltersStyles } from "@bg/Overrides/Widgets/ProductList/ProductListAttributeFilters";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productListAttributeFiltersStyles.seeAllLink = {
    color: "text.main",
    css: css`
        margin-top: 15px;
        &,
        span {
            color: ${getColor("text.main")} !important;
            font-size: ${fontConfig.fontSize.small}px;
            letter-spacing: 0;
            line-height: ${fontConfig.lineHeight.singleLineSmall};
            font-weight: ${fontConfig.weight.regular};
        }
    `,
};
productListAttributeFiltersStyles.seeLessLink = {
    color: "text.main",
    css: css`
        margin-top: 15px;
        &,
        span {
            color: ${getColor("text.main")} !important;
            font-size: ${fontConfig.fontSize.small}px;
            letter-spacing: 0;
            line-height: ${fontConfig.lineHeight.singleLineSmall};
            font-weight: ${fontConfig.weight.regular};
        }
    `,
};
